<template>
  <hm-content title="">
    <div class="table-panel flex flex-between item-center">
      <div style="font-weight: 600; font-size: 15px">
        用户{{ row.memberName }}（手机号{{ row.memberMobile }}）在{{
          row.planName
        }}中的全部推送记录
      </div>
      <div>
        <el-select
          size="small"
          clearable
          placeholder="请选择"
          v-model="searchCondition.queryStatus"
          class="mr10"
          filterable
        >
          <el-option label="全部状态" value=""></el-option>
          <el-option label="已通知" value="noticeSuccess"></el-option>
          <el-option label="已付款" value="pay"></el-option>
          <el-option label="已访问" value="visit"></el-option>
          <el-option label="通知失败" value="noticeFail"></el-option>
        </el-select>
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.createTimeArry"
          type="datetimerange"
          align="right"
          start-placeholder="请选择开始时间"
          end-placeholder="请选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output('queryList', '推送记录')"
          >导出</el-button
        >
      </div>
    </div>
    <div>
      <el-table
        stripe
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        max-height="500"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendTitle"
          label="推送标题"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="推送时间"
        ></el-table-column>
        <el-table-column
          header-align="left"
          align="left"
          label="状态"
          prop="planStatus"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="scope.row.payStatus === 'yes'" class="success">
              已付款
            </div>
            <div
              class="success"
              v-else-if="
                scope.row.payStatus === 'no' && scope.row.visitStatus === 'yes'
              "
            >
              已访问
            </div>
            <div
              class="success"
              v-else-if="
                scope.row.payStatus === 'no' &&
                scope.row.visitStatus === 'no' &&
                scope.row.noticeStatus === 'yes'
              "
            >
              已通知
            </div>
            <div v-else-if="scope.row.noticeStatus === 'no'">
              <span class="danger">通知失败 </span> 原因：{{
                scope.row.noticeFailReasons
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="left"
          label="通知商品"
          prop="goodsinfo"
          width="800"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.spuName }}【复购周期
              <span class="primary">{{ scope.row.repurchaseCycleNum }}</span
              >天】客户{{ scope.row.saleTime }}【<span class="primary">{{
                scope.row.day
              }}</span
              >天前】 购买数量{{ scope.row.goodsNum }}
              <span
                @click="viewOrder(scope.row)"
                class="blue"
                size="small"
                type="text"
                >查看订单详情</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div> -->
    </div>
    <el-dialog
      title="订单详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <el-scrollbar :vertical="false" wrap-style="height: 500px;">
        <div class="mb20">
          <span class="mr20">会员：{{ row.memberName }}</span>
          消费：<span class="primary">￥{{ currentRow.totPrice }}</span>
        </div>
        <div class="dialog-body">
          <div class="mb20">
            <div class="table-panel title">商品信息</div>
            <div class="table">
              <el-table
                stripe
                border
                :data="orderDetail"
                style="width: 100%"
                id="table"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  prop="spu_name"
                  align="center"
                  label="商品名"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="市场价"
                >
                  <template slot-scope="scope">
                    <span class="primary">￥{{ scope.row.market_price }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="门店价"
                >
                  <template slot-scope="scope">
                    <span class="primary">￥{{ scope.row.shop_price }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  prop="goods_number"
                  align="center"
                  label="商品数量"
                ></el-table-column>
              </el-table>
            </div>
          </div>
          <div v-if="couponInfo.length">
            <div class="table-panel title">购买后已发放优惠券</div>
            <div class="table">
              <el-table
                stripe
                border
                :data="couponInfo"
                style="width: 100%"
                id="table"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  prop="name"
                  align="center"
                  label="优惠券名"
                />
                <el-table-column
                  header-align="center"
                  prop="sendName"
                  align="center"
                  label="发放规则名"
                />
                <el-table-column
                  header-align="center"
                  prop="toOrder"
                  align="center"
                  label="已使用订单号"
                />
                <el-table-column
                  header-align="center"
                  prop="couponCode"
                  align="center"
                  label="优惠券码"
                />
                <el-table-column
                  header-align="center"
                  align="center"
                  label="优惠券状态"
                >
                  <template slot-scope="scope">
                    <span class="primary" v-if="scope.row.couponStatus === 2"
                      >已使用</span
                    >
                    <span class="primary" v-if="scope.row.couponStatus === 4"
                      >未使用</span
                    >
                    <span class="primary" v-if="scope.row.couponStatus === 5"
                      >冻结</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer flex flex-center">
        <!-- <el-button @click="sendCoupon(currentRow)" size="small" type="primary"
          >发券</el-button
        > -->
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      row: JSON.parse(this.$route.query.row),
      currentRow: {},
      couponInfo: [],
      orderDetail: [],
      dialogVisible: false,
      total: 0,
      list: [],
      pageSize: 10,
      currentPage: 1,
      searchCondition: {
        centerId: JSON.parse(this.$route.query.row).centerId,
        planId: JSON.parse(this.$route.query.row).planId
      },
      type: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async viewOrder(row) {
      const { result } = await this.$store.dispatch(
        "queryOfflineOrderDetails",
        {
          orderId: row.orderId,
          orderOfflineId: row.orderOfflineId
        }
      );
      const { couponInfo, orderDetail } = result;
      this.couponInfo = couponInfo;
      this.orderDetail = orderDetail;
      this.currentRow = row;
      this.dialogVisible = true;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    data(row) {
      this.$router.push({
        name: "PlanningData",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    add() {
      this.$router.push({
        name: "SetMessagesPush"
      });
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(
        this.searchCondition.createTimeArry
      )
        ? searchCondition.createTimeArry[0]
        : "";
      searchCondition.queryEndTime = this.isArray(
        this.searchCondition.createTimeArry
      )
        ? searchCondition.createTimeArry[1]
        : "";
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "getRepurchasePlanSendMemberDetails",
        params
      );
      if (code === "0") {
        // const { total, records } = result;
        result.forEach(v => {
          let m1 = moment();
          let m2 = moment(v.saleTime);
          this.$set(v, "day", m1.diff(m2, "day") + 1);
        });
        this.list = result;
        return result;
        // this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res;
            list.forEach(v => {
              if (v.planStatus === "yes") {
                v.planStatus = "已付款";
              } else if (v.payStatus === "no" && v.visitStatus === "yes") {
                v.planStatus = "已访问";
              } else if (
                v.payStatus === "no" &&
                v.visitStatus === "no" &&
                v.noticeStatus === "yes"
              ) {
                v.planStatus = "已通知";
              } else if (v.noticeStatus === "no") {
                v.planStatus = "通知失败   原因：" + v.noticeFailReasons;
              }
              v.goodsinfo =
                v.spuName +
                " 【复购周期" +
                v.repurchaseCycleNum +
                "天】客户" +
                v.saleTime +
                "【" +
                v.day +
                "天前】 购买数量" +
                v.goodsNum;
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
